import bodyClass from "discourse/helpers/body-class";
import CommunityTopicAggregation from "../components/community-topic-aggregation";

export default <template>
  {{bodyClass "community-game-page"}}
  <CommunityTopicAggregation @model={{@model}} />
</template>;
